import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
// import NProgress from 'nprogress';
// import PullToRefresh from 'pulltorefreshjs';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'flag-icon-css/css/flag-icon.css';

import App from './App.vue';
import router from './router';
import store from './store/index';
import Cookies from './cookies';

import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import helpers from './plugins/helpers';
import './registerServiceWorker';

global._ = _;
global.axios = axios;
global.pusherKey = process.env.VUE_APP_PUSHER_KEY;
global.moment = moment;
// global.PullToRefresh = PullToRefresh;
// global.NProgress = NProgress;
global.constants = {
    ALERT_TYPE_OUTAGE: 1,
    ALERT_TYPE_RECOVERY: 2,
    SKIP_RECOVERY_CHANNELS: ['12'],
};

if (process.env.VUE_APP_BUGSNAG_KEY) {
    Bugsnag.start({
        apiKey: process.env.VUE_APP_BUGSNAG_KEY,
        appVersion: process.env.VUE_APP_VERSION ?? null,
        releaseStage: process.env.VUE_APP_ENVIRONMENT ?? 'development',
        plugins: [new BugsnagPluginVue()],
        enabledReleaseStages: ['production', 'staging'],
    });
    Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);
    global.Bugsnag = Bugsnag;
}

Vue.config.productionTip = false;
Vue.config.devtools = true;

console.log(`[i81n] Locale is ${i18n.locale}, fallback to ${i18n.fallbackLocale}. Setting moment and axios...`);
moment.locale(i18n.locale);
axios.defaults.headers.common['Accept-Language'] = `${i18n.locale}, ${i18n.fallbackLocale};q=0.2`;

if (Cookies.read('imp-token')) {
    console.log('Adding axios imp-token');
    axios.defaults.headers.common.Authorization = `Bearer ${Cookies.read(
        'imp-token',
    )}`;
    global.impersonation = true;
} else if (Cookies.read('user-token')) {
    console.log('Adding axios user-token');
    axios.defaults.headers.common.Authorization = `Bearer ${Cookies.read('user-token')}`;
}

new Vue({
    comments: false,
    mixins: [helpers],
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');
